import React, { Component } from 'react';
import { TextInput, ButtonLink } from '@youngcapital/component-library';
import { validUniqueEmail } from '@youngcapital/validations';
import { get, isEmpty } from 'lodash';
import mailcheck from 'mailcheck';

import { FIELDSET_PROPTYPES, asFieldset } from '../asFieldset';
import EmailUniquenessChecker from '../../../services/emailUniquenessChecker';
import { whenFieldHasValueHideText } from '../helpers/utils';

const emailChecker = new EmailUniquenessChecker();
const isUniqueEmail = email => emailChecker.isUnique(email).catch(() => true);

class EmailFieldset extends Component {
  static type = 'email';

  static validationSchema = () => ({
    email: validUniqueEmail(isUniqueEmail).required()
  });

  static initialValues = () => ({
    email: ''
  });

  // eslint-disable-next-line react/state-in-constructor
  state = {
    suggestedEmail: ''
  };

  constructor(props) {
    super(props);
    this.emailFieldProps = props.getFieldProps('email');
  }

  getEmailFieldProps() {
    return this.props.getFieldProps('email', props => ({
      ...props,
      onChange: event => {
        const email = get(event, 'target.value', '');
        props.setValue(email.trim());
      }
    }));
  }

  checkEmail = event => {
    mailcheck.run({
      email: event.target.value,
      suggested: suggestion =>
        this.setState({
          suggestedEmail: suggestion.full
        }),
      empty: () => this.setState({ suggestedEmail: '' })
    });
  };

  onAcceptEmailSuggestion = setValue => () => {
    setValue(this.state.suggestedEmail);
    this.setState({ suggestedEmail: '' });
  };

  handleBlur = event => {
    emailChecker.assertUnique(event.target.value);
    this.checkEmail(event);
    this.emailFieldProps.onBlur(event);
  };

  render() {
    const { t } = this.props;
    const emailProps = this.getEmailFieldProps();

    const introText = t('fieldset_email.intro', { defaultValue: '' });
    const subText = t('fieldset_email.subtext', { defaultValue: '' });

    return (
      <>
        <h3>{t('fieldset_email.header')}</h3>
        {introText && <p>{introText}</p>}
        <TextInput
          label={t('fieldset_email.email_label')}
          tooltipContent={whenFieldHasValueHideText(
            emailProps.value,
            t('fieldset_email.email_tooltip')
          )}
          {...emailProps}
          onBlur={this.handleBlur}
          isRequired
          hoverTooltipProps={{ noHover: true }}
          type='email'
        />
        {subText && <p className='text--italic mt-1x'>{subText}</p>}
        {!isEmpty(this.state.suggestedEmail) && (
          <p className='flex-row' data-testid='email_suggestion'>
            {t('fieldset_email.email_suggestion')}
            <ButtonLink
              type='button'
              style={{ margin: '0px 0.2em' }}
              data-testid='accept_suggestion'
              onClick={this.onAcceptEmailSuggestion(emailProps.setValue)}
            >
              {this.state.suggestedEmail}
            </ButtonLink>
            ?
          </p>
        )}
      </>
    );
  }
}

EmailFieldset.propTypes = FIELDSET_PROPTYPES;

export default asFieldset(EmailFieldset);
